import type { FormResponse } from '@/js/api/forms.ts';
import { makeApiRoute, makeRequest } from '@/js/api/request-service.ts';

export async function review(productId: number, data: FormData) {
  return makeRequest<FormResponse>({
    url: makeApiRoute(`products/${productId}/review`),
    data,
  });
}
